export default class NovoPedidoViewModel {
    constructor () {
        this.Id = undefined;
        this.NumeroSolicitacao = undefined;
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.ProdutoNovo = undefined;
        this.LinhaProdução = undefined;
        this.ClienteId = undefined;
        this.DataInicio = undefined;
        this.DataTermino = undefined;
        this.UnidadeId = undefined;
        this.Status = undefined;
        this.Ordenacao = undefined;
        this.Periodo = undefined;
        this.OrcamentoId = undefined;
        this.MarkupRelacaoId = undefined;
        this.Preco = undefined;
        this.Comissao = undefined;
        this.UnidadeId = undefined;
        this.TipoPedido = undefined;
        this.RepresentanteId = undefined;
        this.TipoOrcamento = undefined;
        this.PedidoSituacao = 1;
    }
}